<template>
  <div class="content-cart container">~
    <div v-if="isLoading" class="loading-overlay">
      <div class="loading-spinner"></div>
    </div>
    <div class="content-billing">
      <div class="content-billing-data container">
        <div class="content-billing-data-address">
          <div class="content-billing-data-address-header">
            <h3>{{ $t('pages.product.billingdata') }}</h3>
          </div>
          <div class="content-billing-data-address-body">
            <div class="content-billing-data-address-body-select">
              <div class="row">
                <div class="col-lg-6 p-0">
                  <select class="form-control-address form-control" name="morada" id=""
                    v-model="billing_data.address_code" @click="setBillingData()">
                    <template>
                      <option value="" selected>NIF</option>
                    </template>
                    <template>
                      <option v-for="(a, i) in addresses" :value="a.code" :key="i">
                        {{ a.nif }}
                      </option>
                    </template>
                  </select>
                  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
                    <path d="M795,746l-10-15h20Z" transform="translate(-785 -731)" fill="var( --green-medium)"
                      fill-rule="evenodd"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-lg-8 item-name">
                <div class="content-input">
                  <input type="text" name="name" value="" placeholder="Nome" v-model="billing_data.name" required />
                </div>
              </div>
              <div class="col-lg-4 item-nif">
                <div class="content-input">
                  <input type="text" name="nif" value="" placeholder="NIF" v-model="billing_data.nif" required />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content-cart-products">
      <h1>{{ $t('pages.product.yourcart') }}</h1>
    </div>
    <div class="content-cart-table" v-for="(ptn, ptnKey) in cart.partner" :key="ptnKey">
      <div class="content-cart-menu">
        <div class="content-cart-menu-btn w-100">
          <div class="content-brand w-100">
            <button @click="goToHomeStore(ptn)" class="btn-return">
              {{ $t('pages.goToBackButton.back') }}
            </button>
            <h3 class="partner-store-name" @click="goToHomeStore(ptn)">{{ ptn.stores[0].businessPartner.name
            }}</h3>
          </div>
        </div>
      </div>
      <div v-for="(store, storeIdx) in ptn.stores" :key="storeIdx">
        <table class="content-cart-table-box table">
          <thead>
            <tr>
              <th scope="col">{{ $t('pages.product.description') }}</th>
              <th scope="col">{{ $t('pages.product.amount') }}</th>
              <th scope="col">{{ $t('pages.product.price') }}</th>
              <th scope="col">{{ $t('pages.product.totalprice') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(product, index) in store.products" :key="index">
              <td scope="row">{{ product.name }}</td>
              <td>
                <div class="number">
                  <button class="minus" v-if="product.pivot.quantity == 1" @click="onRemove(product, product.cart_id)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.698" height="5.536" viewBox="0 0 22.698 5.536">
                      <path d="M1.584-9.312v5.536h22.7V-9.312Z" transform="translate(-1.584 9.312)"
                        fill="var( --green-medium)" />
                    </svg>
                  </button>
                  <button class="minus" @click="onUpdate(product, product.pivot.quantity--)" v-else>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22.698" height="5.536" viewBox="0 0 22.698 5.536">
                      <path d="M1.584-9.312v5.536h22.7V-9.312Z" transform="translate(-1.584 9.312)"
                        fill="var( --green-medium)" />
                    </svg>
                  </button>
                  <input type="text" v-model="product.pivot.quantity" />
                  <button class="plus" @click="onUpdate(product, product.pivot.quantity++)">
                    <svg xmlns="http://www.w3.org/2000/svg" width="19.704" height="19.704" viewBox="0 0 19.704 19.704">
                      <path d="M8.768-12.912v7.594H1.224V-.8H8.768V6.792h4.566V-.8h7.594V-5.318H13.335v-7.594Z"
                        transform="translate(-1.224 12.912)" fill="var( --green-medium)" />
                    </svg>
                  </button>
                </div>
              </td>
              <td>{{ product.iva_price | money }}</td>
              <template v-if="product.iva_promotional_price > 0">
                <td>{{ product.iva_promotional_price | money }}</td>
              </template>
              <template v-else>
                <td>{{ product.iva_price | money }}</td>
              </template>
            </tr>
          </tbody>
        </table>
        <div class="content-cart-total">
          <p>
            Total Produtos: <span>{{ store.total_price | money }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="content-cart-address" v-show="true">
      <div class="content-cart-address-header">
        <h3>{{ $t('pages.product.deliveryadress') }}</h3>
      </div>
      <div class="content-cart-address-body">
        <div class="row">
          <div class="col-lg-6">
            <div class="content-cart-address-body-select">
              <select class="form-control-address" name="morada" id="" v-model="deliveryAddress.address_code"
                @click="setAddress()">
                <template>
                  <option value="" selected>{{ $t('pages.product.address') }}</option>
                </template>
                <template>
                  <option v-for="(morada, moradaIndex) in delivery" :value="morada.code" :key="moradaIndex">{{
                    morada.label }}</option>
                </template>
              </select>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15">
                <path d="M795,746l-10-15h20Z" transform="translate(-785 -731)" fill="var( --green-medium)"
                  fill-rule="evenodd"></path>
              </svg>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="content-input">
              <input type="text" name="morada" value="" placeholder="Morada" v-model="deliveryAddress.street" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="content-input">
              <input type="text" name="porta" value="" placeholder="Porta" v-model="deliveryAddress.door" />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="content-input">
              <input type="text" name="andar" value="" placeholder="Andar" v-model="deliveryAddress.floor" />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="content-input">
              <input type="text" name="lado" value="" placeholder="Lado" v-model="deliveryAddress.side" />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="content-input">
              <input type="text" name="postal" value="" placeholder="Código Postal"
                v-model="deliveryAddress.postal_code" />
            </div>
          </div>
          <div class="col-lg-6">
            <div class="content-input">
              <input type="text" name="morada" value="" placeholder="Localidade" v-model="deliveryAddress.locality" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container total-cart">
      <div class="total-cart-card">
        <div class="total-cart-card-item row">
          <p class="col-6 p-0">Transporte:</p>
          <span class="col-6 p-0 total-cart-card-item-subtotal">
            {{ (cart.total_price * computedDeliveryRate) | money }}
          </span>
        </div>
        <div class="total-cart-card-item row">
          <h4 class="col-6 p-0">{{ $t('pages.product.totalpayable') }}:</h4>
          <span class="col-6 p-0 total-cart-card-item-total">{{ totalIncludingDelivery | money }}</span>
        </div>
      </div>
    </div>


    <!-- <form class="paymentSPG" :spg-context="this.formContext" :spg-config="this.formConfig" :spg-style="this.formStyle">
    </form> -->
    <div class="content-input-check check-cart">
      <input v-model="showpayments" type="checkbox" name="terms" required />
      <label class="check-cart-label">Li e aceito os
        <router-link tag="a" :to="{
          name: 'Politica',
          params: {
            slug: 'termos-e-condicoes-de-vendautilizacao',
          },
        }">
          Termos e Condições</router-link>
        e a
        <router-link tag="a" :to="{
          name: 'Politica',
          params: { slug: 'politica-de-privacidade' },
        }">Política de Privacidade</router-link>
      </label>
    </div>
    <template v-if="this.showpayments == true">
      <div class="content-cart-payment">
        <div class="content-cart-payment-header">
          <h3>{{ $t('pages.product.paymentdata') }}</h3>
        </div>
        <div class="content-cart-payment-body">
          <div class="row">
            <div class="col-lg-4">
              <a class="carts" :class="{ 'active-cart': isActiveMbway }" @click="mbWayTelModal()">
                <div class="carts-icon">
                  <svg id="Artwork_5" data-name="Artwork 5" xmlns="http://www.w3.org/2000/svg" width="113.001"
                    height="54.849" viewBox="0 0 113.001 54.849" class="icon-mbway">
                    <g id="Grupo_127" data-name="Grupo 127" transform="translate(0 0)">
                      <path id="Caminho_134" data-name="Caminho 134"
                        d="M4.358,149.394l-.186,1.486a1.238,1.238,0,0,0,1.238,1.362H53.419a1.238,1.238,0,0,0,1.238-1.362l-.186-1.486a2.136,2.136,0,0,1,1.857-2.322,2.074,2.074,0,0,1,2.291,1.857l.186,1.424c.371,3.219-1.455,6.036-4.7,6.036H4.7c-3.25,0-5.076-2.817-4.7-6.036l.186-1.424a2.074,2.074,0,0,1,2.291-1.857,2.136,2.136,0,0,1,1.857,2.322"
                        transform="translate(0.054 -101.54)" fill="#c8001b" />
                      <path id="Caminho_135" data-name="Caminho 135"
                        d="M23.667,0H60.161C63.6,0,65.3,2.569,65.7,6l.155,1.083a2.136,2.136,0,0,1-1.888,2.352,2.1,2.1,0,0,1-2.291-1.888L61.523,6.5c-.155-1.3-.712-2.291-2.012-2.291H24.317c-1.331,0-1.857.991-2.012,2.291l-.155,1.052A2.1,2.1,0,0,1,19.86,9.441a2.136,2.136,0,0,1-1.888-2.352L18.127,6c.4-3.436,2.1-6,5.541-6"
                        transform="translate(-12.384)" fill="#c8001b" />
                      <path id="Caminho_136" data-name="Caminho 136"
                        d="M127.25,68.058a3.933,3.933,0,0,0,4.148-3.931c-.062-2.229-2.136-3.776-4.457-3.776h-4.7a1.95,1.95,0,1,1,0-3.9h3.157c2.1-.093,3.745-1.362,3.838-3.374a3.89,3.89,0,0,0-4.024-3.776h-7.615V68.058Zm5.788-15.012a6.2,6.2,0,0,1-1.826,4.426l-.124.124.155.093A7.617,7.617,0,0,1,135.2,64.1a7.855,7.855,0,0,1-7.924,7.986H115.642a2.074,2.074,0,0,1-2.043-2.1V47.5a2.074,2.074,0,0,1,2.043-2.1h9.6a7.571,7.571,0,0,1,7.8,7.615"
                        transform="translate(-78.42 -31.347)" fill="#040505" />
                      <path id="Caminho_137" data-name="Caminho 137"
                        d="M20.253,64.468l.062.155.062-.155c.526-1.486,1.176-3.126,1.888-4.922s1.424-3.683,2.1-5.386,1.393-3.281,2.043-4.643a15.786,15.786,0,0,1,1.579-2.848A3.126,3.126,0,0,1,30.5,45.525h.5a2.229,2.229,0,0,1,1.517.464,1.7,1.7,0,0,1,.619,1.052l3,23.277a1.919,1.919,0,0,1-.526,1.393,2.043,2.043,0,0,1-1.455.5,2.383,2.383,0,0,1-1.517-.433,1.641,1.641,0,0,1-.712-1.176c-.093-.774-.186-1.641-.279-2.569s-.588-4.983-.743-6.036-.96-7.645-1.269-10v-.217l-.96,2.012q-.5,1.052-1.083,2.507c-.371.96-.774,1.981-1.176,3.064s-2.291,6.345-2.291,6.345l-.8,2.352c-.31.9-.557,1.7-.65,1.857a2.693,2.693,0,0,1-4.8,0c-.093-.155-.34-.96-.65-1.857s-.619-1.857-.8-2.352c0,0-1.857-5.293-2.26-6.345s-.774-2.1-1.176-3.064-.743-1.8-1.052-2.507l-.96-2.012v.217c-.279,2.383-1.114,8.946-1.269,10s-.588,5.076-.712,6.036-.186,1.8-.279,2.569A1.671,1.671,0,0,1,8,71.773a2.414,2.414,0,0,1-1.517.433,2.043,2.043,0,0,1-1.455-.5A1.95,1.95,0,0,1,4.5,70.318l3-23.277a1.733,1.733,0,0,1,.619-1.052,2.229,2.229,0,0,1,1.517-.5h.5a3.126,3.126,0,0,1,2.507,1.145,15.91,15.91,0,0,1,1.61,2.879q.96,2.043,2.043,4.643t2.136,5.386c.681,1.8,1.331,3.436,1.857,4.922"
                        transform="translate(-3.088 -31.41)" fill="#040505" />
                      <path id="Caminho_138" data-name="Caminho 138"
                        d="M226.818,66.076l-.774,3.126q-.4,1.671-.8,3.188c-.279,1.021-.526,1.888-.774,2.662a9.619,9.619,0,0,1-.588,1.579,1.578,1.578,0,0,1-1.486.743l-.774-.124a1.3,1.3,0,0,1-.836-.712,8.8,8.8,0,0,1-.588-1.641c-.248-.8-.5-1.764-.774-2.817s-.526-2.2-.8-3.374-.5-2.291-.712-3.312l-.526-2.6c-.155-.712-.217-1.145-.248-1.3a1.081,1.081,0,0,1-.031-.186v-.093a.9.9,0,0,1,.341-.743,1.3,1.3,0,0,1,.867-.279,1.362,1.362,0,0,1,.774.186,1.176,1.176,0,0,1,.433.712c0,.031.062.279.155.774l.371,1.826.5,2.507c.186.929.371,1.857.588,2.817s.4,1.857.619,2.755.4,1.641.588,2.291l.588-2.043.65-2.383.619-2.476.557-2.291.433-1.888q.186-.836.279-1.207a1.455,1.455,0,0,1,.5-.8,1.424,1.424,0,0,1,.9-.279,1.455,1.455,0,0,1,.959.31,1.393,1.393,0,0,1,.464.774l.65,2.91.712,3.25c.248,1.083.5,2.167.774,3.219s.526,1.981.774,2.786c.186-.65.371-1.393.588-2.291l.619-2.724.619-2.786.526-2.476.371-1.8.155-.712a1.177,1.177,0,0,1,.433-.712,1.362,1.362,0,0,1,.774-.186,1.331,1.331,0,0,1,.867.279.9.9,0,0,1,.341.743v.093a1.3,1.3,0,0,1-.031.186c-.031.155-.093.557-.248,1.3l-.557,2.538q-.31,1.517-.712,3.281t-.774,3.343c-.248,1.052-.5,2.012-.743,2.817a9.005,9.005,0,0,1-.588,1.641,1.393,1.393,0,0,1-.8.712,2.847,2.847,0,0,1-.774.155h-.31l-.464-.093a1.762,1.762,0,0,1-.464-.248,1.146,1.146,0,0,1-.371-.464,11.7,11.7,0,0,1-.588-1.671q-.34-1.176-.712-2.631t-.774-3.1l-.681-3"
                        transform="translate(-149.882 -41.56)" fill="#040505" />
                      <path id="Caminho_139" data-name="Caminho 139"
                        d="M285.351,72.423c-.279.836-.5,1.641-.712,2.352s-.4,1.331-.588,1.8a1.342,1.342,0,0,1-2.074.464,1.114,1.114,0,0,1-.279-.774,1.083,1.083,0,0,1,.062-.34l.34-1.083q.279-.929.743-2.321l.991-3.033q.557-1.641,1.145-3.25c.4-1.083.774-2.074,1.145-3a19.059,19.059,0,0,1,1.052-2.26,1.176,1.176,0,0,1,.588-.619,2.508,2.508,0,0,1,.96-.155,2.476,2.476,0,0,1,.991.186,1.053,1.053,0,0,1,.588.65q.371.8.9,2.136l1.083,2.91q.588,1.548,1.145,3.188l1.021,3,.8,2.383.4,1.269a1.207,1.207,0,0,1,.062.34,1.052,1.052,0,0,1-.31.774,1.3,1.3,0,0,1-.929.309,1.021,1.021,0,0,1-.681-.186,1.331,1.331,0,0,1-.371-.557c-.186-.464-.4-1.052-.619-1.8l-.8-2.383Zm5.912-2.322q-.557-1.733-1.052-3.188t-1.052-2.755l-.279-.681-.186-.464a2.522,2.522,0,0,0-.186.433l-.279.712q-.526,1.3-1.021,2.755L286.156,70.1Z"
                        transform="translate(-194.487 -41.563)" fill="#040505" />
                      <path id="Caminho_140" data-name="Caminho 140"
                        d="M331.228,70.721l-.248-.31-.248-.371a10.863,10.863,0,0,1-.8-1.3c-.278-.526-.588-1.052-.867-1.61l-.867-1.7-.743-1.61-.588-1.3a5.123,5.123,0,0,1-.309-.743l-.062-.186a1.209,1.209,0,0,1,0-.186,1.052,1.052,0,0,1,.341-.8,1.269,1.269,0,0,1,.929-.31.96.96,0,0,1,.743.279,1.8,1.8,0,0,1,.34.526l.248.588.5,1.114.65,1.455.774,1.579.743,1.486a9.683,9.683,0,0,0,.681,1.145,18.966,18.966,0,0,0,1.083-1.95l1.114-2.322.929-2.012.464-1.083a2.013,2.013,0,0,1,.34-.526.96.96,0,0,1,.774-.279,1.269,1.269,0,0,1,.929.31,1.053,1.053,0,0,1,.341.8.944.944,0,0,1,0,.186l-.062.186-.31.774-.557,1.3-.8,1.61-.867,1.7-.867,1.61a10.818,10.818,0,0,1-.8,1.3,4.691,4.691,0,0,1-.5.619V76.2a1.208,1.208,0,1,1-2.414,0Z"
                        transform="translate(-225.413 -41.625)" fill="#040505" />
                    </g>
                  </svg>
                </div>
                <button class="btn btn-success">
                  <template v-if="!isActiveMbway">
                    {{ $t('generic.select') }}
                  </template>
                  <template v-else> {{ $t('generic.selected') }} </template>
                </button>
              </a>
            </div>
            <div class="col-lg-4">
              <a class="carts" :class="{ 'active-cart': isActiveMultibanco }"
                @click="isActiveMultibanco = true; isActiveMbway = false; isActiveVisaMastercard = false; payment_method = 'REFERENCE';">
                <div class="carts-icon">
                  <svg xmlns="http://www.w3.org/2000/svg" width="60.631" height="70.771" viewBox="0 0 60.631 70.771"
                    class="icon-multibanco">
                    <g id="Artwork_9" data-name="Artwork 9" transform="translate(36.518 42.625)">
                      <g id="Grupo_217" data-name="Grupo 217" transform="translate(-36.518 -42.625)">
                        <path id="Caminho_179" data-name="Caminho 179"
                          d="M55.8,79.312v1.494a1.577,1.577,0,0,0,1.577,1.577h.581a1.577,1.577,0,0,0,1.577-1.577V79.312a1.577,1.577,0,0,0-1.577-1.577h-.581A1.577,1.577,0,0,0,55.8,79.312m4.815,1.577a2.74,2.74,0,0,1-2.657,2.656h-.5a2.74,2.74,0,0,1-2.74-2.74V79.312a2.74,2.74,0,0,1,2.74-2.74h.5a2.74,2.74,0,0,1,2.657,2.74Zm-10.128-1.66v1.826a1.494,1.494,0,0,0,1.494,1.494h1.743a.581.581,0,0,1,0,1.079H51.985a2.573,2.573,0,0,1-2.573-2.573V79.146a2.573,2.573,0,0,1,2.573-2.573h1.743a.581.581,0,0,1,0,1.079H51.985a1.411,1.411,0,0,0-1.494,1.411m-3.155-1.909a.54.54,0,1,1,1.079,0v5.977a.5.5,0,0,1-.166.332l-.415.166h-.5l-.415-.249-2.075-2.989-1.66-2.075v4.9a.54.54,0,1,1-1.079,0V77.071a.5.5,0,0,1,.166-.332l.415-.166h.5l.415.249,2.241,2.989A24.857,24.857,0,0,1,47.336,81.8Zm-7.471,3.985h-2.49a.54.54,0,0,1,0-1.079h2.407l-.166-.747a1.743,1.743,0,0,0-1.577-1.66,1.66,1.66,0,0,0-1.577,1.66l-.581,3.653q-.125.5-.5.5a.5.5,0,0,1-.5-.5l.581-3.653a2.74,2.74,0,0,1,2.74-2.74c1.494,0,2.49,1,2.74,2.74l.581,3.653a.5.5,0,0,1-.5.5.44.44,0,0,1-.5-.5Zm-7.471-2.574a.913.913,0,0,0-.913-.83H29.488v4.732h2.49a1,1,0,0,0,1.079-1,1.079,1.079,0,0,0-1.162-.913H30.65a.581.581,0,1,1,0-1.079h.83a.913.913,0,0,0,1-.83m-5.728,4.981a.581.581,0,0,1-.581-.581V77.237a.581.581,0,1,1,1.079,0v5.811a.581.581,0,0,1-.581.581m-4.317,0a.5.5,0,0,1-.5-.5v-5.4H20.107a.54.54,0,0,1,0-1.079h4.649a.54.54,0,0,1,0,1.079H23.012v5.313a.5.5,0,0,1-.5.5m-5.4-6.392v3.819a1.494,1.494,0,0,0,1.494,1.494h1.66a.581.581,0,1,1,0,1.079h-1.66a2.574,2.574,0,0,1-2.573-2.573V77.154a.581.581,0,0,1,1.079,0m-4.9,5.313a1.743,1.743,0,0,0,1.743-1.743v-3.57a.54.54,0,1,1,1.079,0v3.57a2.823,2.823,0,0,1-5.645,0v-3.57a.54.54,0,1,1,1.079,0v3.57a1.743,1.743,0,0,0,1.743,1.743M2.673,80.226c-.249-.664-.664-1.328-.913-1.909L1.1,83.048c-.083.332-.249.581-.5.581a.5.5,0,0,1-.5-.5l.747-5.4v-.581a.5.5,0,0,1,.166-.332l.415-.166h.166a.747.747,0,0,1,.664.332A22.746,22.746,0,0,1,3.67,79.81l.664,1.909L5,79.81a22.578,22.578,0,0,1,1.411-2.823.747.747,0,0,1,.664-.332h.166l.415.166a.5.5,0,0,1,.166.332v.581l.747,5.4a.5.5,0,0,1-.5.5c-.332,0-.5-.166-.5-.581l-.664-4.732c-.249.581-.664,1.245-.913,1.909s-1,2.74-1,2.906l-.249.332h-.83l-.249-.332c-.083-.083-.581-1.743-1-2.823m26.233-3.57H31.48a1.992,1.992,0,0,1,2.075,1.992,1.577,1.577,0,0,1-.5,1.162,1.992,1.992,0,0,1,1.079,1.66,2.075,2.075,0,0,1-2.158,1.992H28.906a.581.581,0,0,1-.581-.581V77.154a.581.581,0,0,1,.581-.581"
                          transform="translate(-0.044 -12.983)" fill-rule="evenodd" />
                        <path id="Caminho_180" data-name="Caminho 180"
                          d="M4.488,59.1,4.322,60.6A1.245,1.245,0,0,0,5.568,62.01H55.045A1.245,1.245,0,0,0,56.29,60.6L56.124,59.1a2.173,2.173,0,1,1,4.317-.5l.166,1.494c.415,3.321-1.494,6.226-4.815,6.226H4.9c-3.321,0-5.23-2.906-4.815-6.226l.166-1.494A2.158,2.158,0,0,1,2.579,56.7,2.158,2.158,0,0,1,4.488,59.1"
                          transform="translate(-0.032 -9.627)" fill="#047bc1" />
                        <path id="Caminho_181" data-name="Caminho 181"
                          d="M57.647,40.893a4.068,4.068,0,0,0,4.234-4.068c-.083-2.407-2.158-3.9-4.566-3.9H52.5a2.034,2.034,0,1,1,0-4.068h3.238a3.849,3.849,0,0,0,3.985-3.487c.166-2.075-1.826-3.9-4.151-3.9h-7.8V40.893Zm5.977-15.524a6.392,6.392,0,0,1-1.909,4.566V30.1h.166a7.887,7.887,0,0,1,4.068,6.641,8.136,8.136,0,0,1-8.136,8.219H45.775A2.158,2.158,0,0,1,43.7,42.8V19.558A2.158,2.158,0,0,1,45.775,17.4h9.8a7.8,7.8,0,0,1,8.053,7.97"
                          transform="translate(-7.449 -2.954)" fill-rule="evenodd" />
                        <path id="Caminho_182" data-name="Caminho 182"
                          d="M17.97,37.074h0l2.075-5.064Q21.124,29.1,22.2,26.448t2.075-4.815a16.105,16.105,0,0,1,1.66-2.989,3.155,3.155,0,0,1,2.573-1.162h.5a2.324,2.324,0,0,1,1.577.5,1.743,1.743,0,0,1,.664,1.079l3.072,24.075a1.992,1.992,0,0,1-.5,1.411,2.075,2.075,0,0,1-1.494.5,2.407,2.407,0,0,1-1.577-.5,1.743,1.743,0,0,1-.747-1.162q-.166-1.162-.332-2.657c-.166-1-.581-5.147-.747-6.226L27.6,24.206v-.249l-1,2.075-1.079,2.573-1.162,3.238c-.415,1.079-2.324,6.558-2.324,6.558l-.83,2.407-.664,1.909a2.74,2.74,0,0,1-4.981,0L14.9,40.81l-.83-2.407s-1.909-5.479-2.324-6.558l-1.162-3.155L9.419,26.033l-1-2.075v.249L7.095,34.5c-.166,1.079-.581,5.23-.747,6.226s-.166,1.826-.332,2.657a1.743,1.743,0,0,1-.747,1.162,2.407,2.407,0,0,1-1.577.5,2.075,2.075,0,0,1-1.494-.5,1.992,1.992,0,0,1-.5-1.494L4.77,18.977A1.743,1.743,0,0,1,5.434,17.9a2.324,2.324,0,0,1,1.577-.5h.5a3.155,3.155,0,0,1,2.573,1.328,16.188,16.188,0,0,1,1.66,2.989q1,1.992,2.075,4.732T16.06,32.01l1.909,5.064"
                          transform="translate(-0.314 -2.954)" />
                        <path id="Caminho_183" data-name="Caminho 183"
                          d="M12.791,0H50.4c3.57,0,5.313,2.657,5.728,6.226l.166,1.079A2.241,2.241,0,0,1,54.3,9.713,2.158,2.158,0,0,1,51.891,7.72l-.083-1C51.642,5.4,51.061,4.4,49.733,4.4H13.455c-1.328,0-1.909,1-2.075,2.324L11.213,7.8A2.158,2.158,0,0,1,8.806,9.8,2.241,2.241,0,0,1,6.9,7.305l.166-1.079C7.478,2.657,9.221,0,12.791,0"
                          transform="translate(-1.195)" fill="#047bc1" />
                      </g>
                    </g>
                  </svg>
                </div>
                <button class="btn btn-success">
                  <template v-if="!isActiveMultibanco">
                    {{ $t('generic.select') }}
                  </template>
                  <template v-else> {{ $t('generic.selected') }} </template>
                </button>
              </a>
            </div>
            <div class="col-lg-4">
              <a class="carts" :class="{ 'active-cart': isActiveVisaMastercard }"
                @click="isActiveVisaMastercard = true; isActiveMbway = false; isActiveMultibanco = false; payment_method = 'CARD';">
                <div class="carts-icon">
                  <svg id="g4158" xmlns="http://www.w3.org/2000/svg" width="83.845" height="27.135"
                    viewBox="0 0 83.845 27.135" class="icon-visa">
                    <path id="polygon9" d="M440.3,136.995h-6.792l4.248-26.268h6.792Z"
                      transform="translate(-403.966 -110.251)" fill="#00579f" />
                    <path id="path11"
                      d="M585.553,106.166a16.74,16.74,0,0,0-6.092-1.118c-6.707,0-11.431,3.577-11.46,8.69-.056,3.773,3.382,5.868,5.953,7.126,2.628,1.285,3.521,2.124,3.521,3.27-.027,1.76-2.123,2.571-4.079,2.571a13.519,13.519,0,0,1-6.373-1.4l-.894-.42-.95,5.9a20.671,20.671,0,0,0,7.575,1.4c7.127,0,11.766-3.521,11.822-8.971.027-2.99-1.788-5.281-5.7-7.154-2.376-1.2-3.83-2.012-3.83-3.242.028-1.118,1.23-2.263,3.912-2.263a11.54,11.54,0,0,1,5.059,1.006l.615.279.924-5.672Z"
                      transform="translate(-524.598 -105.048)" fill="#00579f" />
                    <path id="path13"
                      d="M801.03,127.689c.559-1.509,2.712-7.35,2.712-7.35-.028.056.558-1.537.894-2.515l.475,2.263s1.286,6.288,1.565,7.6Zm8.384-16.962h-5.254a3.352,3.352,0,0,0-3.55,2.179l-10.089,24.088h7.127l1.426-3.94h8.72c.195.922.81,3.94.81,3.94h6.289l-5.479-26.267Z"
                      transform="translate(-731.048 -110.251)" fill="#00579f" />
                    <path id="path15"
                      d="M182.6,110.727l-6.652,17.912-.727-3.633c-1.23-4.192-5.087-8.746-9.39-11.01l6.093,22.971h7.182l10.676-26.24Z"
                      transform="translate(-158.737 -110.251)" fill="#00579f" />
                    <path id="path17"
                      d="M92.205,110.727H81.278l-.112.531c8.524,2.18,14.17,7.434,16.489,13.75l-2.376-12.072c-.391-1.678-1.593-2.153-3.074-2.208Z"
                      transform="translate(-81.166 -110.251)" fill="#faa61a" />
                  </svg>
                  <svg id="Grupo_126" data-name="Grupo 126" xmlns="http://www.w3.org/2000/svg" width="55.358"
                    height="43.07" viewBox="0 0 55.358 43.07" class="icon-mastercard">
                    <g id="Grupo_30" data-name="Grupo 30" transform="translate(0 0)">
                      <g id="Grupo_26" data-name="Grupo 26" transform="translate(2.817 36.456)">
                        <path id="Caminho_30" data-name="Caminho 30"
                          d="M-134.269-15.745v.112h.1a.109.109,0,0,0,.057-.014.049.049,0,0,0,.021-.042.047.047,0,0,0-.021-.041.1.1,0,0,0-.057-.014Zm.1-.078a.191.191,0,0,1,.124.036.119.119,0,0,1,.044.1.112.112,0,0,1-.035.086.17.17,0,0,1-.1.041l.137.158h-.107l-.127-.157h-.041v.157h-.089v-.419Zm-.027.564a.331.331,0,0,0,.136-.028.357.357,0,0,0,.111-.075.349.349,0,0,0,.075-.112.358.358,0,0,0,.027-.137.359.359,0,0,0-.027-.137.361.361,0,0,0-.075-.112.357.357,0,0,0-.111-.075.348.348,0,0,0-.136-.026.363.363,0,0,0-.138.026.354.354,0,0,0-.113.075.342.342,0,0,0-.074.112.339.339,0,0,0-.027.137.339.339,0,0,0,.027.137.331.331,0,0,0,.074.112.354.354,0,0,0,.113.075.345.345,0,0,0,.138.028m0-.8a.452.452,0,0,1,.18.036.455.455,0,0,1,.146.1.443.443,0,0,1,.1.144.431.431,0,0,1,.036.175.431.431,0,0,1-.036.175.468.468,0,0,1-.1.144.494.494,0,0,1-.146.1.452.452,0,0,1-.18.036.459.459,0,0,1-.182-.036.473.473,0,0,1-.147-.1.468.468,0,0,1-.1-.144.431.431,0,0,1-.036-.175.432.432,0,0,1,.036-.175.443.443,0,0,1,.1-.144.438.438,0,0,1,.147-.1.459.459,0,0,1,.182-.036m-42.39-1.613a1.364,1.364,0,0,1,1.378-1.455,1.362,1.362,0,0,1,1.369,1.455,1.362,1.362,0,0,1-1.369,1.455,1.364,1.364,0,0,1-1.378-1.455m3.679,0v-2.272h-.988v.552a1.722,1.722,0,0,0-1.435-.666,2.277,2.277,0,0,0-2.273,2.386,2.277,2.277,0,0,0,2.273,2.386,1.722,1.722,0,0,0,1.435-.666v.552h.988Zm33.384,0a1.364,1.364,0,0,1,1.378-1.455,1.362,1.362,0,0,1,1.369,1.455,1.362,1.362,0,0,1-1.369,1.455,1.364,1.364,0,0,1-1.378-1.455m3.68,0v-4.1h-.989V-19.4a1.722,1.722,0,0,0-1.435-.666,2.277,2.277,0,0,0-2.273,2.386,2.277,2.277,0,0,0,2.273,2.386,1.722,1.722,0,0,0,1.435-.666v.552h.989Zm-24.8-1.5a1.129,1.129,0,0,1,1.15,1.1h-2.358a1.17,1.17,0,0,1,1.208-1.1m.02-.885a2.22,2.22,0,0,0-2.263,2.386,2.241,2.241,0,0,0,2.329,2.386,2.762,2.762,0,0,0,1.863-.636l-.484-.732a2.173,2.173,0,0,1-1.322.475,1.262,1.262,0,0,1-1.359-1.113h3.374c.01-.123.02-.247.02-.38a2.179,2.179,0,0,0-2.158-2.386m11.929,2.386a1.364,1.364,0,0,1,1.378-1.455,1.362,1.362,0,0,1,1.369,1.455,1.362,1.362,0,0,1-1.369,1.455,1.364,1.364,0,0,1-1.378-1.455m3.679,0v-2.272H-146v.552a1.724,1.724,0,0,0-1.435-.666,2.277,2.277,0,0,0-2.273,2.386,2.277,2.277,0,0,0,2.273,2.386A1.724,1.724,0,0,0-146-15.958v.552h.988Zm-9.258,0a2.3,2.3,0,0,0,2.424,2.386,2.379,2.379,0,0,0,1.634-.542l-.474-.8a2,2,0,0,1-1.189.409,1.357,1.357,0,0,1-1.369-1.455,1.357,1.357,0,0,1,1.369-1.455,2,2,0,0,1,1.189.409l.474-.8a2.379,2.379,0,0,0-1.634-.542,2.3,2.3,0,0,0-2.424,2.386m12.737-2.386a1.341,1.341,0,0,0-1.2.666v-.552h-.979v4.543h.989v-2.547c0-.752.323-1.17.969-1.17a1.6,1.6,0,0,1,.618.114l.3-.931a2.1,2.1,0,0,0-.7-.124m-26.483.475a3.4,3.4,0,0,0-1.853-.475c-1.151,0-1.892.552-1.892,1.455,0,.741.552,1.2,1.568,1.34l.467.066c.542.076.8.219.8.475,0,.351-.361.552-1.036.552a2.42,2.42,0,0,1-1.511-.475l-.466.769a3.278,3.278,0,0,0,1.967.59c1.312,0,2.073-.618,2.073-1.483,0-.8-.6-1.216-1.587-1.359l-.466-.067c-.428-.057-.77-.141-.77-.446,0-.333.323-.532.865-.532a2.931,2.931,0,0,1,1.417.39Zm12.747-.475a1.338,1.338,0,0,0-1.2.666v-.552h-.979v4.543h.988v-2.547c0-.752.323-1.17.969-1.17a1.6,1.6,0,0,1,.618.114l.3-.931a2.1,2.1,0,0,0-.7-.124m-8.431.114h-1.616v-1.378h-1v1.378h-.922v.9h.922v2.073c0,1.054.409,1.682,1.578,1.682a2.319,2.319,0,0,0,1.236-.351l-.285-.846a1.829,1.829,0,0,1-.875.257c-.494,0-.655-.3-.655-.761v-2.053h1.616Zm-14.772,4.543v-2.852a1.692,1.692,0,0,0-1.788-1.806,1.759,1.759,0,0,0-1.6.808,1.668,1.668,0,0,0-1.5-.808,1.5,1.5,0,0,0-1.331.675v-.56h-.989v4.543h1v-2.519a1.063,1.063,0,0,1,1.113-1.208c.656,0,.988.428.988,1.2v2.529h1v-2.519a1.072,1.072,0,0,1,1.112-1.208c.675,0,1,.428,1,1.2v2.529Z"
                          transform="translate(185.679 21.774)" fill="#231f20" />
                      </g>
                      <g id="Grupo_27" data-name="Grupo 27" transform="translate(53.394 27.051)">
                        <path id="Caminho_31" data-name="Caminho 31"
                          d="M-3.765-1.733V-2.4h-.173l-.2.456-.2-.456h-.174v.664h.123v-.5L-4.2-1.8h.127l.187-.433v.5Zm-1.1,0v-.551h.222V-2.4h-.566v.112h.222v.551Z"
                          transform="translate(5.207 2.397)" fill="#f79410" />
                      </g>
                      <path id="Caminho_32" data-name="Caminho 32" d="M3357.976,2174.48H3343v-26.909h14.972Z"
                        transform="translate(-3322.813 -2143.91)" fill="#ff5f00" />
                      <g id="Grupo_28" data-name="Grupo 28" transform="translate(0 0)">
                        <path id="Caminho_33" data-name="Caminho 33"
                          d="M-55.241-44.7A17.084,17.084,0,0,1-48.705-58.15a17.038,17.038,0,0,0-10.575-3.659A17.112,17.112,0,0,0-76.392-44.7,17.112,17.112,0,0,0-59.281-27.583a17.038,17.038,0,0,0,10.575-3.659A17.084,17.084,0,0,1-55.241-44.7"
                          transform="translate(76.392 61.809)" fill="#eb001b" />
                      </g>
                      <g id="Grupo_29" data-name="Grupo 29" transform="translate(27.67 0)">
                        <path id="Caminho_34" data-name="Caminho 34"
                          d="M-72.314-44.7A17.112,17.112,0,0,1-89.425-27.583,17.043,17.043,0,0,1-100-31.242,17.082,17.082,0,0,0-93.464-44.7,17.082,17.082,0,0,0-100-58.15a17.043,17.043,0,0,1,10.576-3.659A17.112,17.112,0,0,1-72.314-44.7"
                          transform="translate(100.001 61.809)" fill="#f79e1b" />
                      </g>
                    </g>
                  </svg>
                </div>
                <button class="btn btn-success">
                  <template v-if="!isActiveVisaMastercard">
                    {{ $t('generic.select') }}
                  </template>
                  <template v-else> {{ $t('generic.selected') }} </template>
                </button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- <div class="content-input-check check-cart">
      <input type="checkbox" name="terms" required />
      <label class="check-cart-label">Li e aceito os
        <router-link tag="a" :to="{
          name: 'Politica',
          params: {
            slug: 'termos-e-condicoes-de-vendautilizacao',
          },
        }">
          {{ $t('pages.product.term') }}</router-link>
        {{ $t('pages.product.and') }}
        <router-link tag="a" :to="{
          name: 'Politica',
          params: { slug: 'politica-de-privacidade' },
        }">{{ $t('pages.product.privacy') }}</router-link>
      </label>
    </div> -->
    <div class="content-cart-finish">
      <button class="btn btn-success" type="submit" @click="createOrder()">
        {{ $t('pages.product.finalizepayment') }}
      </button>
    </div>
    <div id="form-container">
      <form class="paymentSPG" ref="formSPG" :spg-context="this.formContext" :spg-config="this.formConfig"
        :spg-style="this.formStyle">
      </form>
    </div>
    <ModalMultiBanco :multiBanco="multiBanco" :price="price" />
    <ModalMbWayTel />
    <ModalMbWayOrder v-if="isActiveMbway && finalizePayment" :products="cart" :payload="payload" />
  </div>
</template>

<script>
import axios from "axios";
import ModalMultiBanco from "@/components/modals/ModalMultiBanco.vue";
import ModalMbWayTel from "@/components/modals/ModalMbWayTel.vue";
import ModalMbWayOrder from "@/components/modals/ModalMbWayOrder.vue";
import GoToBackButton from "@/components/goToBackButton/GoToBackButton.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      isLoading: false,
      showpayments: false,
      multiBanco: {},
      mbWayTel: {},
      card: {},
      price: '',
      payment_method: "",
      access_token: this.$store.getters["User/userIsLogged"],
      visitor_token: localStorage.getItem("visitor_token"),
      isActiveMbway: false,
      isActiveMultibanco: false,
      isActiveVisaMastercard: false,
      payload: "",
      formContext: "",
      formStyle: '{"transaction":{{"layout":"default","theme":"default","color":{"primary":"","secondary":"","border":"","surface":"","header":{"text":"","background":""},"body":{"text":"","background":""}},"font":""}',
      transactionID: "",
      formConfig: "",
      billing_data: {
        access_token: this.$store.getters['User/userIsLogged'],
        nif: '',
        name: '',
      },
      deliveryAddress: {
        access_token: this.$store.getters['User/userIsLogged'],
        locality: '',
        door: '',
        floor: '',
        side: '',
        postal_code: '',
        street: '',
        label: '',
      },
      addresses: [],
      delivery: [],
      finalizePayment: false,
    };
  },
  components: {
    GoToBackButton,
    ModalMultiBanco,
    ModalMbWayTel,
    ModalMbWayOrder,
  },
  computed: {
    ...mapGetters({
      cart: "Cart/cart",
    }),
    totalIncludingDelivery() {
      let deliveryRatePercent = this.cart.products[0]?.store?.delivery_rate / 100 || 0;
      let totalPrice = this.cart.total_price || 0;
      let deliveryCost = totalPrice * deliveryRatePercent;
      return totalPrice + deliveryCost;
    }
  },
  methods: {
    ...mapActions("Cart", ["getCartByPartner", "updateCart", "removeCart", "clearCart"]),
    goToHomeStore(partner) {
      this.$router.push({
        name: "HomeStore",
        params: { slug: partner.slug },
      });
    },
    // aqui fica observando o iframa carregar e scrolar até o formulario
    observeIframeLoading() {
      const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(node => {
              if (node.tagName === 'IFRAME') {
                this.waitForIframeLoad(node);
                observer.disconnect();
              }
            });
          }
        });
      });
      const config = { childList: true, attributes: true, subtree: true };
      const targetNode = document.getElementById('form-container');
      observer.observe(targetNode, config);
    },


    scrollToIframe(iframe) {
      this.$nextTick(() => {
        if (iframe) {
          iframe.scrollIntoView({ behavior: 'smooth' });
        }
      });
    },
    // loading até carregar o iframe
    waitForIframeLoad(iframe) {
      if (iframe.attachEvent) {
        iframe.attachEvent("onload", () => {
          this.isLoading = false; // Parar carregamento quando o iframe carregar
          this.scrollToIframe(iframe);
        });
      } else {
        iframe.onload = () => {
          this.isLoading = false; // Parar carregamento quando o iframe carregar
          this.scrollToIframe(iframe);
        };
      }
    },
    // fim funcoes do iframe
    onUpdate(item) {
      this.$store.dispatch("setIsLoading", true);
      axios.post("/api/v1/ecommerce/update", {
        access_token: this.access_token,
        product: item.uuid,
        quantity: item.pivot.quantity,
      }).then((response) => {
        if (response) {
          this.$store.dispatch("Cart/getCartByPartner", { access_token: this.access_token });
        }
      }).catch((error) => {
        console.log(error);
      });
    },
    onRemove(product, cart_id) {
      this.$store.dispatch("Cart/removeCart", {
        product: product.uuid,
        cart_id,
        access_token: this.access_token,
        page: "cart",
      });
    },
    onClear() {
      this.$store.dispatch("Cart/clearCart", {
        product: 'all',
        access_token: this.access_token,
        page: "cart",
      });
    },

    btnSize(index) {
      this.idSize = index;
    },
    sendOrder() {
      if (this.isActiveMbway === true) {
        this.sendMbway();
        this.payment_method = "MBWAY";
      }
      if (this.isActiveMultibanco === true) {
        this.sendMultibanco();
        this.payment_method = "REFERENCE";
      }
      if (this.isActiveVisaMastercard === true) {
        this.sendCard();
        this.payment_method = "CARD";
      }
    },
    mbWayTelModal() {
      this.isActiveMbway = true;
      this.isActiveMultibanco = false;
      this.payment_method = 'MBWAY';
      this.isActiveVisaMastercard = false;
      this.$bvModal.show("modal-mbwaytel");
    },
    sendMbway() {
      console.log("Chamada sendMbway");
      this.$store.dispatch("setIsLoading", true);
      axios.post("api/v1/payment/mbway", {
        payload: this.payload,
        phone: localStorage.getItem("mbwaytelphone"),
      })
        .then((response) => {
          console.log('Resposta da API:', response.data);
          localStorage.setItem("transactionID", response.data.resp.transactionID);
          this.$store.dispatch("setIsLoading", false);
          if (response.status == 200) {
            this.$bvModal.show("modal-mbwayorder");
            this.onClear();
          }
        })
        .catch((error) => {
          console.log("Erro na chamada sendMbway:", error);
        });
      localStorage.removeItem("mbwaytelphone");
    },

    sendMultibanco() {
      this.$store.dispatch("setIsLoading", true);
      axios.post("/api/v1/payment/reference", { payload: this.payload })
        .then((response) => {
          console.log("response");
          console.log(response);
          this.$store.dispatch("setIsLoading", false);
          if (response.status == 200) {
            this.multiBanco = response.data.resp.paymentReference;
            this.price = response.data.resp.paymentReference.amount.value;
            this.$bvModal.show("modal-multibanco");
            this.onClear();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    sendCard() {
      this.isLoading = true;
      axios.post("api/v1/payment/card", { payload: this.payload })
        .then((response) => {
          console.log('Resposta da API:', response.data);
          var scriptTag = document.createElement("script");
          scriptTag.src = `https://spg.qly.site1.sibs.pt/assets/js/widget.js?id=${response.data.transactionID}`;
          document
            .getElementsByTagName("head")[0]
            .appendChild(scriptTag);

          console.log(response.data);

          this.transactionID = response.data.transactionID;
          this.formContext = response.data.formContext;
          this.formConfig = response.data.formConfig;
          this.onClear();
          console.log('formConfig', this.formConfig);
        })
        .catch((error) => {
          console.log(error);
          this.isLoading = false;
        });
    },
    createOrder() {
      this.finalizePayment = true;
      localStorage.removeItem("transactionID")
      const totalPriceIncludingDelivery = this.totalIncludingDelivery;
      axios.post("api/v1/ecommerce/createorder", {
        access_token: this.access_token,
        payment_method: this.payment_method,
        billing_address: this.billing_data.address_code,
        delivery_address: this.deliveryAddress.address_code,
        total_price: totalPriceIncludingDelivery
      })
        .then((response) => {
          if (response.status == 200) {
            this.payload = response.data.payload;
            this.sendOrder();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDataCart() {
      this.$store.dispatch("Cart/getCartByPartner", {
        access_token: this.access_token,
      });
    },
    setBillingData() {
      if (this.billing_data.address_code == "") {
        this.clearForm();
      } else {
        for (var i = 0; i < this.addresses.length; i++) {
          if (this.addresses[i].code == this.billing_data.address_code) {
            this.billing_data.nif = this.addresses[i].nif;
            this.billing_data.name = this.addresses[i].name;
          }
        }
      }
    },
    setAddress() {
      if (this.deliveryAddress.address_code == "") {
        this.clearForm();
      } else {
        for (var i = 0; i < this.delivery.length; i++) {
          if (this.delivery[i].code == this.deliveryAddress.address_code) {
            this.deliveryAddress.locality = this.delivery[i].locality;
            this.deliveryAddress.door = this.delivery[i].door;
            this.deliveryAddress.floor = this.delivery[i].floor;
            this.deliveryAddress.postal_code = this.delivery[i].postal_code;
            this.deliveryAddress.street = this.delivery[i].street;
            this.deliveryAddress.side = this.delivery[i].side;
            this.deliveryAddress.label = this.delivery[i].label;
          }
        }
      }
    },
    listBillingAddresses() {
      axios.post('api/v1/invoice-address/list', { access_token: this.billing_data.access_token })
        .then(response => {
          this.addresses = response.data.moradas;
          if (this.addresses.length > 0) {
            this.billing_data.address_code = this.addresses[0].code;
            this.setBillingData();
            // console.log('billing data', this.billing_data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    listAddresses() {
      axios.post('api/v1/address/list', { access_token: this.deliveryAddress.access_token })
        .then(response => {
          this.delivery = response.data.moradas;
          console.log("MORADAS", this.delivery);
          if (this.delivery.length > 0) {
            this.deliveryAddress.address_code = this.delivery[0].code;
            this.setAddress();
            // console.log('billing data', this.billing_data);
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    clearForm() {
      this.billing_data.nif = "";
      this.billing_data.name = "";
      this.deliveryAddress.locality = "";
      this.deliveryAddress.door = "";
      this.deliveryAddress.floor = "";
      this.deliveryAddress.postal_code = "";
      this.deliveryAddress.street = "";
      this.deliveryAddress.side = "";
      this.deliveryAddress.label = "";
    },
  },
  mounted() {
    this.listAddresses();
    this.listBillingAddresses();
    this.$store.dispatch("Cart/updateToken", { access_token: this.access_token, visitor_token: this.visitor_token })
      .then(() => {
        this.getDataCart();
      });
    this.observeIframeLoading();
  },
};
</script>

<style lang="scss" scoped>
/* Table Colors */

$colorTitle: #112d23;
$colorLetters: #112d23;
$colorSubTitle: var(--green-medium);
$colorLettersGray: #878787;
$colorBg: #d8d8d8;

/* End Table Colors */

/* CSS Cart */

.content-cart {
  margin-top: 130px;
  margin-bottom: 150px;

  @media (max-width: 991px) {
    margin-top: 90px;
    margin-bottom: 70px;
  }

  &-menu {
    display: flex;
    align-items: center;
  }

  &-btn {
    .content-brand-elements {
      width: calc(100% - 100px);
      text-align: left;
    }
  }

  &-return {
    p {
      margin-bottom: 0;
      color: $colorLetters;
      font-family: "Font Semibold";
      font-size: 25px;
      margin-left: 20px;
    }
  }

  &-products {
    text-align: left;
    margin-top: 70px;
    margin-bottom: 15px;

    @media (max-width: 991px) {
      margin-top: 30px;
      margin-bottom: 0;
    }

    h1 {
      font-family: "Font Bold";
      color: $colorTitle;
      font-size: 50px;
      margin-bottom: 0;

      @media (max-width: 991px) {
        font-size: 30px;
      }
    }

    h3 {
      font-family: "Font Bold";
      font-size: 28px;
      color: $colorSubTitle;
      margin-top: 30px;
      margin-bottom: 0;

      @media (max-width: 991px) {
        margin-top: 20px;
        font-size: 24px;
      }
    }
  }

  &-table {
    margin: 50px 0;

    @media (max-width: 767px) {
      overflow-x: scroll;
    }

    &-box {
      margin: 0;

      @media (max-width: 767px) {
        width: 700px;
      }

      thead {
        border-bottom: 1px solid var(--green-medium);

        th {
          font-family: "Font Regular";
          font-size: 20px;
          color: var(--green-medium);
          font-weight: normal;
          text-align: left;
          border: 0;
          padding: 20px 0px;

          &:last-child {
            text-align: center;
          }
        }
      }

      tbody {
        border-bottom: 1px solid var(--green-medium);

        td {
          font-family: "Font Regular";
          color: var(--green-dark);
          font-size: 24px;
          border: none;
          text-align: left;
          font-weight: normal;
          border: none;
          // vertical-align: baseline;
          padding: 20px 0px;

          .number {
            display: flex;
            justify-content: space-between;
            border: 1px solid $colorBg;
            border-radius: 10px;
            width: 125px;
            height: 45px;

            .minus {
              position: relative;
              width: 25px;
              height: 100%;
              font-family: "Font Bold";
              color: var(--green-medium);
              background: 0;
              border: 0;

              svg {
                position: absolute;
                right: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 60%;
              }
            }

            input {
              width: 60px;
              height: 100%;
              background: 0;
              border: none;
              text-align: center;
              outline: none;
              font-size: 25px;
              font-family: "Font Regular";
              color: var(--green-dark);
            }

            .plus {
              position: relative;
              width: 25px;
              height: 100%;
              font-family: "Font Bold";
              color: var(--green-medium);
              background: 0;
              border: 0;

              svg {
                position: absolute;
                left: 0;
                top: 50%;
                transform: translateY(-50%);
                width: 60%;
              }
            }
          }

          &:nth-child(2) {
            width: 20%;
          }

          &:nth-child(3),
          &:nth-child(4) {
            width: 15%;
            font-family: "Font Bold";
            font-size: 22px;
            text-align: center;
          }
        }
      }
    }
  }

  &-total {
    display: flex;
    justify-content: flex-end;
    flex-direction: column;
    align-items: flex-end;
    margin-top: 20px;

    p {
      font-family: "Font Regular";
      font-size: 22px;
      color: $colorLettersGray;
      margin-bottom: 0;

      span {
        color: var(--green-medium);
        font-family: "Font Bold";
        font-size: 35px;
      }
    }
  }

  &-address {
    margin: 55px 0px 130px 0px;

    @media (max-width: 991px) {
      margin: 35px 0px 75px 0px;
    }

    &-header {
      text-align: left;
      margin-bottom: 35px;

      h3 {
        font-size: 28px;
        font-family: "Font Bold";
        color: var(--green-medium);
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 24px;
        }
      }
    }

    &-body {
      &-select {
        position: relative;
        width: 100%;

        select {
          width: 100%;
          height: 70px;
          border-radius: 10px;
          font-family: "Font Regular";
          font-size: 25px;
          outline: none;
          box-shadow: none;
          border: 1px solid #bebebe;
          border-radius: 10px;
          padding: 0px 50px 0px 25px;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;

          @media (max-width: 991px) {
            font-size: 18px;
            padding: 0px 40px 0px 25px;
          }
        }

        svg {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          right: 30px;
          pointer-events: none;

          @media (max-width: 991px) {
            right: 20px;
          }
        }
      }

      input {
        width: 100%;
        border: 1px solid #bebebe;
        border-radius: 10px;
        height: 70px;
        color: $colorLettersGray;
        font-family: "Font Regular";
        font-size: 25px;
        border: 1px solid #bebebe;
        border-radius: 10px;
        color: var(--green-dark);
        padding: 0px 25px;
        margin-top: 45px;
        outline: none;

        @media (max-width: 991px) {
          font-size: 18px;
          margin-top: 20px;
        }

        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #b7b8b8;
        }

        &::-moz-placeholder {
          /* Firefox 19+ */
          color: #b7b8b8;
        }

        &:-ms-input-placeholder {
          /* IE 10+ */
          color: #b7b8b8;
        }

        &:-moz-placeholder {
          /* Firefox 18- */
          color: #b7b8b8;
        }
      }
    }
  }

  &-charge {
    margin-top: 130px;

    @media (max-width: 991px) {
      margin-top: 0px;
    }

    &-header {
      text-align: left;

      h3 {
        font-size: 28px;
        font-family: "Font Bold";
        color: var(--green-medium);
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 24px;
        }
      }
    }

    input:not([type="checkbox"]) {
      width: 100%;
      border: 1px solid #bebebe;
      border-radius: 10px;
      height: 70px;
      color: $colorLettersGray;
      font-family: "Font Regular";
      font-size: 25px;
      border: 1px solid #bebebe;
      border-radius: 10px;
      color: var(--green-dark);
      padding: 0px 25px;
      margin-top: 45px;
      outline: none;

      @media (max-width: 991px) {
        font-size: 18px;
        margin-top: 20px;
      }

      &::-webkit-input-placeholder {
        /* Chrome/Opera/Safari */
        color: #b7b8b8;
      }

      &::-moz-placeholder {
        /* Firefox 19+ */
        color: #b7b8b8;
      }

      &:-ms-input-placeholder {
        /* IE 10+ */
        color: #b7b8b8;
      }

      &:-moz-placeholder {
        /* Firefox 18- */
        color: #b7b8b8;
      }
    }
  }

  &-payment {
    margin-top: 140px;

    @media (max-width: 991px) {
      margin-top: 80px;
    }

    &-header {
      text-align: left;

      h3 {
        font-size: 28px;
        font-family: "Font Bold";
        color: var(--green-medium);
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 24px;
        }
      }
    }

    &-body {
      margin-top: 60px;

      @media (max-width: 991px) {
        margin-top: 20px;
      }

      .carts {
        width: 100%;
        height: 250px;
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        border: 1px solid #bebebe;
        border-radius: 10px;
        transition: 500ms;
        cursor: pointer;

        @media (max-width: 991px) {
          height: 125px;
          flex-direction: row;
          justify-content: space-between;
          margin-bottom: 30px;
          padding: 20px;
        }

        @media (max-width: 400px) {
          padding: 20px 15px;
        }

        &:hover:not(.active-cart) {
          opacity: 0.6;
        }

        &-icon {
          height: 72px;

          @media (max-width: 991px) {
            width: 120px;
            height: initial;

            .icon-mbway {
              max-width: 80px;
            }

            .icon-multibanco {
              max-width: 53px;
            }

            .icon-visa {
              max-width: 60px;
            }

            .icon-mastercard {
              max-width: 40px;
            }
          }

          svg {
            &:first-child:not(:last-child) {
              margin-right: 50px;

              @media (max-width: 991px) {
                margin-right: 20px;
              }

              @media (max-width: 359px) {
                margin-right: 10px;
              }
            }
          }
        }

        button {
          height: 60px;
          width: 160px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 22px;
          font-family: "Font Regular";
          color: var(--green-medium);
          border-radius: 10px;
          background-color: var(--white);
          box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
          transition: 500ms;
          margin-top: 30px;

          @media (max-width: 991px) {
            margin-top: 0;
          }

          @media (max-width: 359px) {
            height: 50px;
            width: 120px;
            font-size: 18px;
          }
        }
      }

      .active-cart {
        box-shadow: inset 0px 3px 6px rgba(0, 0, 0, 0.16);

        button {
          background: var(--green-medium);
          color: var(--white);
        }
      }
    }
  }

  &-summary {
    display: flex;
    margin-top: 110px;

    @media (max-width: 991px) {
      margin-top: 40px;
    }

    &-header {
      text-align: left;
      margin-bottom: 60px;

      @media (max-width: 991px) {
        margin-bottom: 30px;
      }

      h3 {
        font-size: 28px;
        font-family: "Font Bold";
        color: var(--green-medium);
        margin-bottom: 0;

        @media (max-width: 991px) {
          font-size: 24px;
        }
      }
    }

    &-body {
      display: flex;
      justify-content: center;
      grid-gap: 65px;

      @media (max-width: 991px) {
        flex-direction: column;
        grid-gap: 0;
      }

      .summary-products {
        @media (max-width: 991px) {
          margin-bottom: 30px;
        }
      }

      p {
        font-family: "Font Regular";
        font-size: 25px;
        color: $colorLettersGray;
        line-height: 1;
        margin-bottom: 0;

        @media (max-width: 991px) {
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 22px;
        }
      }

      span {
        font-family: "Font Bold";
        font-size: 30px;
        color: #555555;
        margin-left: 25px;

        @media (max-width: 991px) {
          margin-left: 0;
        }

        @media (max-width: 400px) {
          font-size: 28px;
        }
      }
    }

    &-total {
      display: flex;
      flex-direction: column;
      margin-top: 55px;
      margin-bottom: 65px;

      @media (max-width: 991px) {
        align-items: center;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 0;
      }

      p {
        font-family: "Font Regular";
        font-size: 22px;
        color: var(--gray);
        margin-bottom: 0;
      }

      span {
        font-family: "Font Bold";
        font-size: 45px;
        color: var(--green-medium);
        line-height: 1;

        @media (max-width: 400px) {
          font-size: 35px;
        }
      }
    }
  }

  &-finish {
    margin-top: 50px;

    button {
      width: 290px;
      height: 75px;
      font-family: "Font Regular";
      color: #fff;
      font-size: 25px;
      border-radius: 10px;
      box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.16);
      background: var(--green-medium);
      border: 1px solid var(--green-medium);
      transition: 500ms;

      @media (max-width: 991px) {
        width: 100%;
        height: 72px;
      }

      &:hover {
        background: var(--white);
        color: var(--green-medium);
      }
    }
  }
}

.partner-store-name {
  font-family: "Font Bold";
  font-size: 30px;
  color: var(--green-medium);
  margin-bottom: 0;

  @media (max-width: 991px) {
    font-size: 24px;
  }

  @media screen and (max-width: 400px) {
    font-size: 20px;
  }
}

.total-cart {
  display: flex;
  justify-content: flex-end;
  padding: 0 !important;
  margin-top: 80px;

  &-card {
    background-color: #E7E7E7;
    width: 556px;
    height: 238px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: space-around;
    padding: 20px;

    &-item {
      display: flex;
      width: 100%;
      justify-content: flex-end;
      align-items: center;
      text-align: right;

      p {
        font-family: "Font Regular";
        font-size: 22px;
        color: #878787;
        margin-bottom: 0;

        @media screen and (max-width: 767px) {
          font-size: 18px;
        }
      }

      h4 {
        font-family: "Font Bold";
        font-size: 22px;
        color: #112D23;
        margin-bottom: 0;

        @media screen and (max-width: 767px) {
          font-size: 18px;
        }
      }

      &-subtotal {
        font-family: 'Font Regular';
        font-size: 30px;
        color: #112D23;
        margin-bottom: 0;

        @media screen and (max-width: 767px) {
          font-size: 24px;
        }
      }

      &-total {
        font-family: 'Font Bold';
        font-size: 40px;
        color: #338545;
        margin-bottom: 0;

        @media screen and (max-width: 767px) {
          font-size: 30px;
        }
      }
    }
  }
}

.check-cart {
  margin-bottom: 0;
  margin-top: 100px !important;
  display: flex;
  justify-content: center !important;

  @media (max-width: 991px) {
    margin-top: 40px;
  }

  &-label {
    width: auto !important;
    ;
  }
}

.content-billing-data {
  margin-bottom: 70px;

  &-address {
    &-header {
      margin-top: 50px;
      display: flex;

      @media (max-width: 991px) {
        margin-top: 10px;
      }

      h3 {
        font-size: 28px;
        font-family: "Font Bold";
        color: $colorSubTitle;

        @media (max-width: 992px) {
          font-size: 24px;
        }
      }
    }

    &-body {
      &-select {
        position: relative;
        padding-bottom: 45px;
        margin-top: 30px;

        select {
          margin-bottom: 0;
        }
      }

      select {
        width: 100%;
        height: 70px;
        background: var(--white);
        border: 1px solid #BEBEBE;
        font-family: "Font Regular";
        font-size: 25px;
        color: var(--green-dark);
        border-radius: 10px;
        padding-inline: 27px;
        outline: none;
        box-shadow: none;
        appearance: none;
        -moz-appearance: none;
        -webkit-appearance: none;

        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #B7B8B8;
        }

        &::-moz-placeholder {
          /* Firefox 19+ */
          color: #B7B8B8;
        }

        &:-ms-input-placeholder {
          /* IE 10+ */
          color: #B7B8B8;
        }

        &:-moz-placeholder {
          /* Firefox 18- */
          color: #B7B8B8;
        }
      }

      svg {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 35px;
        pointer-events: none;

        @media (max-width: 992px) {
          height: 30%;
        }
      }

      input {
        width: 100%;
        height: 70px;
        background: var(--white);
        border: 1px solid #BEBEBE;
        font-family: "Font Regular";
        font-size: 25px;
        color: var(--green-dark);
        margin-bottom: 30px;
        border-radius: 10px;
        padding-inline: 27px;
        outline: none;
        box-shadow: none;

        @media (max-width: 991px) {
          margin-bottom: 20px;
        }

        &::-webkit-input-placeholder {
          /* Chrome/Opera/Safari */
          color: #B7B8B8;
        }

        &::-moz-placeholder {
          /* Firefox 19+ */
          color: #B7B8B8;
        }

        &:-ms-input-placeholder {
          /* IE 10+ */
          color: #B7B8B8;
        }

        &:-moz-placeholder {
          /* Firefox 18- */
          color: #B7B8B8;
        }
      }
    }
  }

  .item-name {
    padding-left: 0 !important;

    @media screen and (max-width: 991px) {
      padding: 0 !important;
    }
  }

  .item-nif {
    padding-right: 0 !important;

    @media screen and (max-width: 991px) {
      padding: 0 !important;
    }
  }
}


.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  border: 5px solid #f3f3f3;
  border-top: 5px solid #338545;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  animation: spin 2s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
}
</style>
